import * as React from 'react';
import { Link } from 'react-router-dom';
import * as _ from 'lodash';
import { Formik } from 'formik';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import * as Util from 'src/util';
import InputErrorClass from './../Shared/InputErrorClass';
import EmptyComponent from 'src/containers/Module/Types/Empty';
import Destinations from 'src/containers/Module/Types/Destinations';
import Contents from 'src/containers/Module/Types/Contents';
import PaymentMethods from 'src/containers/Module/Types/PaymentMethods';
import SearchBox from 'src/containers/Module/Types/SearchBox';
import Packages from 'src/containers/Module/Types/Packages';
import Images from 'src/containers/Module/Types/Images';
import Cards from 'src/containers/Module/Types/Cards';
import Contact from 'src/containers/Module/Types/Contact';
import About from 'src/containers/Module/Types/About';
import Activities from 'src/containers/Module/Types/Activities';
import Text from 'src/containers/Module/Types/Text';
import PackagesList from 'src/containers/Module/Types/PackagesList';
import Breadcrumbs from 'src/containers/Module/Types/Breadcrumbs';
import DestinationsActivities from 'src/containers/Module/Types/DestinationsActivities';
import ContentsParams from 'src/containers/Module/Types/ContentsParams';
import Hotels from 'src/containers/Module/Types/Hotels';

import { Input } from './../Shared/BsInput';
import { MODULE_TYPES, LANGUAGES } from 'src/globals';

const getDynamicForm = ({ type, ...rest }: any): any => {
  switch (type) {
    case 'CONTACT': {
      return <Contact { ...rest } />
    }
    case 'CARDS': {
      return <Cards { ...rest } />
    }
    case 'IMAGES': {
      return <Images { ...rest } />
    }
    case 'DESTINATIONS': {
      return <Destinations { ...rest } />
    }
    case 'CONTENTS': {
      return <Contents { ...rest } />
    }
    case 'PAYMENT_METHODS': {
      return <PaymentMethods { ...rest } />
    }
    case 'SEARCH_BOX': {
      return <SearchBox { ...rest } />
    }
    case 'PACKAGES': {
      return <Packages { ...rest } />
    }
    case 'ACTIVITIES': {
      return <Activities { ...rest } />
    }
    case 'TEXT': {
      return <Text { ...rest } />
    }
    case 'PACKAGES_LIST': {
      return <PackagesList { ...rest } />
    }
    case 'BREADCRUMBS': {
      return <Breadcrumbs { ...rest } />
    }
    case 'DESTINATIONS_ACTIVITIES': {
      return <DestinationsActivities { ...rest } />
    }
    case 'CONTENTS_SEARCH': {
      return <ContentsParams { ...rest } />
    }
    case 'ABOUT': {
      return <About { ...rest } />
    }
    case 'HOTELS': {
      return <Hotels { ...rest } />
    }
    case 'SOCIAL':
    case 'SUBSCRIBE_NEWSLETTER': {
      return <EmptyComponent />
    }
  }
};

const RenderForm = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  handleSubmit,
  isSubmitting,
  setFieldValue,
}: any) => {
  let { type } = values;
  return (
    <form onSubmit={handleSubmit} autoComplete="off">
      <div className="row">
        <div className="col">
          <Tabs className="nav-fill" style={{ cursor: 'pointer' }}>
            <TabList>
              {
                Object.keys(LANGUAGES).map((key: string, index: number) => (
                  <Tab key={index}>{LANGUAGES[key]}</Tab>
                ))
              }
            </TabList>
            {
              Object.keys(LANGUAGES).map((key: string, index: number) => (
                <TabPanel key={index}>
                  <Input
                    label={`Titulo (${key})`}
                    name={`translations.${key}.title`}
                    onChange={handleChange}
                    value={values.translations[key].title}
                    errors={errors}
                  />
                  <Input
                    label={`Link (${key})`}
                    name={`translations.${key}.link`}
                    onChange={handleChange}
                    value={values.translations[key].link}
                    errors={errors}
                  />
                  <Input
                    label={`Titulo Link (${key})`}
                    name={`translations.${key}.linkTitle`}
                    onChange={handleChange}
                    value={values.translations[key].linkTitle}
                    errors={errors}
                  />
                </TabPanel>
              ))
            }
          </Tabs>
        </div>
        <div className="col">
          <Input
            label="Estilo"
            type="text"
            name="style"
            onChange={handleChange}
            value={values.style}
            errors={errors}
          />
          <div className="form-group">
            <label>Tipo de modulo</label>
            <select
              className={InputErrorClass({ errors, name: 'type' })}
              name="type"
              onChange={(e: any) => {
                const { value } = e.currentTarget;
                setFieldValue('type', value, false);
                type = value;
                // setDynamicForm({ values, handleChange, setFieldValue, type: 'value' });
              }}
              value={values.type}
            >
              {
                Object.keys(MODULE_TYPES).map((key: string, i: number) => {
                  return (
                    <option key={i} value={key}>{MODULE_TYPES[key]}</option>
                  );
                })
              }
            </select>
            {errors.type && <p className="invalid-feedback">{errors.type}</p>}
          </div>
          <div>
            {getDynamicForm({ values, setFieldValue, handleChange, type, errors })}
          </div>
        </div>
      </div>
      <div className="form-group text-right">
        <button type="submit" className="btn btn-lg btn-dark" disabled={isSubmitting}>
          GUARDAR
        </button>
      </div>
    </form>
  );
}

export default class ModuleForm extends React.Component<any, any> {
  public render() {
    const { onSubmit, loading, contentId }: any = this.props;
    const initialValues = Util.replaceNullWithEmptyString(this.props.module);

    return (
      <div className="card mb-5">
        <div className="card-header bg-primary text-white">
          <h3 className="mb-0">
            <i className="fa fa-pencil-square"></i> Modulos
            <div className="pull-right">
              <Link className="btn btn-light" to={`/editar/${contentId}`}>
                <i className="fa fa-pencil"></i> Contenido
              </Link>
              &nbsp;
              <Link className="btn btn-light" to={`/modulos/${contentId}`}>
                <i className="fa fa-arrow-circle-left"></i> Volver
              </Link>
            </div>
          </h3>
        </div>
        <div className="card-body">
          {
            !loading && <Formik
              initialValues={initialValues}
              enableReinitialize={true}
              onSubmit={
                async (values: any, { setSubmitting, setErrors }: any) => {
                  try {
                    const cleanValues = _.pick(_.cloneDeep(values), [
                      'style', 'type', 'data', 'position',
                      'content_id', 'translations',
                    ]);

                    await onSubmit(Util.replaceEmptyStringWithNull(cleanValues));
                  } catch (err) {
                    if (err.response.data.errors) {
                      setErrors(err.response.data.errors);
                    }

                    setSubmitting(false);
                  }
                }
              }
              render={RenderForm}
            >
            </Formik>
          }

        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Module/form.tsx